import { Card } from "features/common/components/Card";
import { useUserPanel } from "./useUserPanel";
import { UserPanelContent } from "./UserPanelContent";
import { UserModalRenderer } from "./UserModalRenderer";
import { InfoApp } from "features/app/components/InfoApp/InfoApp";
import { useMemo } from "react";

export const UserPanel = () => {
  const {
    userLabel,
    navMenuConfig,
    handleClick,
    openModal,
    modalName,
    userGrantsError,
    userGrantsIsFetching,
    refetchUserGrants,
    showAlertMessage,
    alertSeverity,
    alertMessage,
    handleCloseModal,
    fileTsError,
  } = useUserPanel();

  const contentPanel = useMemo(
    () => () =>
      (
        <UserPanelContent
          navMenuConfig={navMenuConfig}
          handleClick={handleClick}
          userGrantsError={userGrantsError}
          userGrantsIsFetching={userGrantsIsFetching}
          refetchUserGrants={refetchUserGrants}
          showAlertMessage={showAlertMessage}
          alertSeverity={alertSeverity}
          alertMessage={alertMessage}
          fileTsError={fileTsError}
        />
      ),
    [
      alertMessage,
      alertSeverity,
      fileTsError,
      handleClick,
      navMenuConfig,
      refetchUserGrants,
      showAlertMessage,
      userGrantsError,
      userGrantsIsFetching,
    ]
  );

  return (
    <>
      <UserModalRenderer
        modalName={modalName}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
      />
      <InfoApp />
      <Card
        title={userLabel}
        style={{ width: "100%", minHeight: "646px" }}
        Component={contentPanel}
      />
    </>
  );
};
